import * as React from "react";

const AlertCircleFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 15a1 1 0 111-1 1 1 0 01-1 1zm1-4a1 1 0 11-2 0V8a1 1 0 112 0v5z"
            />
        </svg>
    );
};

export default React.memo(AlertCircleFill);
